import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiExtendedDeviation } from '@wix/da-papi-types';
import UserLink from '../../../../User/Link/UserLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, LocationClickBiEvent, SubjectClickBiEvent } from '@wix/da-bi/pkg/events';

import s from './Subjects.scss';

export interface Props {
  subjectTags: PapiExtendedDeviation['subjectTags'];
  locationTag: PapiExtendedDeviation['locationTag'];
  className?: string;
}

export const Subjects: React.FC<Props> = ({ className, subjectTags, locationTag }) => {
  const { t } = useTranslation();
  if ((!subjectTags || !subjectTags.length) && !locationTag) {
    return null;
  }
  return (
    <div className={classnames(s['root'], className)}>
      {subjectTags &&
        subjectTags.map(subject => (
          <span key={subject.name} className={s['subject']}>
            <span className={s['subject-title']}>{t!(`deviation.subject.${subject.type}`)}</span>
            &nbsp;&nbsp;
            {subject.user && <UserLink user={subject.user} />}
            {!subject.user && (
              <BiLink
                className={s['subject-name']}
                href={subject.url}
                biData={BiData<SubjectClickBiEvent>({
                  evid: 392,
                  subject_name: subject.name,
                  subject_type: subject.type,
                })}
              >
                {subject.name}
              </BiLink>
            )}
          </span>
        ))}
      {locationTag && (
        <span className={s['subject']}>
          <span className={s['subject-title']}>{t!('deviation.subject.location')}</span>
          &nbsp;&nbsp;
          <BiLink
            className={s['subject-name']}
            href={locationTag.url}
            biData={BiData<LocationClickBiEvent>({
              evid: 393,
              location_name: locationTag.name,
            })}
          >
            {locationTag.name}
          </BiLink>
        </span>
      )}
    </div>
  );
};
Subjects.displayName = 'Subjects';

export default Subjects;
